import React from 'react'
import { XMarkIcon } from '@heroicons/react/20/solid'

export interface ChipItem {
  id: string
  label: string
  color?: string
  /** round avatar shown before the label (takes precedence over color) */
  avatarUrl?: string
}

interface SelectedChipsProps {
  items: Array<ChipItem>
  onRemove: (id: string) => void
}

export const SelectedChips: React.FC<SelectedChipsProps> = ({ items, onRemove }) => {
  if (items.length === 0) return null

  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      {items.map((item) => (
        <span
          key={item.id}
          className={`inline-flex items-center gap-1.5 rounded-full bg-gray-100 py-1 pr-1 text-xs text-gray-700 ${
            item.avatarUrl ? 'pl-1' : 'pl-2.5'
          }`}
        >
          {item.avatarUrl ? (
            <img
              src={item.avatarUrl}
              alt=""
              loading="lazy"
              className="h-6 w-6 rounded-full object-cover"
            />
          ) : (
            item.color && (
              <span className="h-2 w-2 rounded-full" style={{ backgroundColor: item.color }} />
            )
          )}
          {item.label}
          <button
            type="button"
            onClick={() => onRemove(item.id)}
            className="rounded-full p-0.5 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-600"
          >
            <XMarkIcon className="h-3.5 w-3.5" />
          </button>
        </span>
      ))}
    </div>
  )
}
